import store from '@/store/store'
import { watch, computed } from 'vue';
export default {

  setWebTitle(pageTitle){


    var newWebTitle = process.env.WEB_TITLE //newVal.name


    watch(() => store.state.webConfig, (newVal, oldVal) => {
      // 当状态变化时，这个函数会被调用
      if(newVal.name){
        newWebTitle = newVal.name
      }
      if(!pageTitle){
        pageTitle = ''
      }
      document.title = newWebTitle+pageTitle
    });





  },
  timeFormatSeconds(time,type) {
  	var d = time ? new Date(time) : new Date();
  	var year = d.getFullYear();
  	var month = d.getMonth() + 1;
  	var day = d.getDate();
  	var hours = d.getHours();
  	var min = d.getMinutes();
  	var seconds = d.getSeconds();

  	if (month < 10) month = '0' + month;
  	if (day < 10) day = '0' + day;
  	if (hours < 0) hours = '0' + hours;
  	if (min < 10) min = '0' + min;
  	if (seconds < 10) seconds = '0' + seconds;

    if(type == 'y'){
      return (year);
    }else if(type == 'm'){
      return (month);
    }else if(type == 'd'){
      return (day);
    }else{
      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    }

  	//
  },



}



// WEBPACK FOOTER //
// ./src/utils/tools.js